import React, { Component } from "react";

export default class SectionContainer extends Component {
  render() {
    const { children, className, ...props } = this.props;
    return (
      <section
        {...props}
        className={["my-32", className].join(" ")}
      >
        <div className="lg:container">
          <div className="grid">{children}</div>
        </div>
      </section>
    );
  }
}
